import React from 'react';
import { getIn } from 'seamless-immutable';
import { withCookies } from '@catalogo/core-connect/cookies';
import ClockIcon from '@catalogo/ui-americanas-desktop-svg/clock.svg';
import styled from 'styled-components';
import { useFreight } from '@catalogo/service-americanas-product/src/hooks/freight';

export const StockAlert = props => {
  const { currentSku, cookies, offer = {} } = props;
  const stockWarning = getIn(offer, ['stockWarning']);
  const hasOffers = !!getIn(currentSku, ['offers', 'result'], []).length;
  const { persistentCep = '' } = cookies;
  const skip = persistentCep.length < 8;
  const { data: freightData } = useFreight({
    cep: persistentCep,
    currentSku,
    skip,
    cache: true,
  });

  const isOutOfStock = getIn(freightData, ['freight', 'error', 'errorCode']) === 'OUT_OF_STOCK';

  if (isOutOfStock || !stockWarning || !hasOffers || !freightData) {
    return null;
  }

  return (
    <Container>
      <ClockIcon fill="#666" width={15} height={15} />
      <Text>Corra! Temos apenas {stockWarning} no estoque.</Text>
    </Container>
  );
};

const Container = styled.div`
  font-size: 14px;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`;

const Text = styled.div`
  font-weight: bold;
  margin-left: 5px;
`;

export default withCookies(StockAlert);
